//final latest
import React, { useEffect, useState } from "react";
import TherapyRoomCard from "./TherapyRoomCard";
import Navbar from "../Navbar";
import Footer from "../Footer";
import beach from "../../assets/images/beach.png";
import forest from "../../assets/images/forest.png";
import campsite from "../../assets/images/campsite.png";
import park from "../../assets/images/park.png";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Env from '../../runtimeEnv';

function ClientTherapyRooms({
  setCurrentNickname,
  currentNickname,
  handleLogout,
  setFormType,
  PlutonicuserID,
  userType,
}) {
  const navigate = useNavigate();
  const [enabledRoom, setEnabledRoom] = useState([]);
  const [loading, setLoading] = useState(true);
  const [roomsOnlineStatus, setRoomsOnlineStatus] = useState({});
  const [sessionStartTimes, setSessionStartTimes] = useState({});
  const [selectedSpace, setSelectedSpace] = useState(null);
  const [meetingExists, setMeetingExists] = useState(false); // ✅ Track if a meeting exists



// useEffect(() => {
//   const initializeState = async () => {
//     const savedUserID = PlutonicuserID || localStorage.getItem("PlutonicuserID");
//     const savedNickname = currentNickname || localStorage.getItem("currentNickname");

//     if (savedNickname) {
//       setCurrentNickname(savedNickname);
//     }

//     if (savedUserID) {
//       try {
//         const response = await axios.get(
//           `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`
//         );

//         if (response.data.length > 0) {
//           const nowEST = new Date(
//             new Date().toLocaleString("en-US", { timeZone: "America/New_York" })
//           );

//           const gracePeriodBeforeMs = 10 * 60 * 1000; // 10 minutes before
//           const gracePeriodAfterMs = 50 * 60 * 1000; // 50 minutes after
//           let hasEligibleMeeting = false;

//           const roomSessionsMap = response.data.reduce((acc, room) => {
//             const roomId = room.meetingID.split("-")[0];
//             const sessionTimeUTC = new Date(room.sessionTime);

//             const sessionTimeEST = new Date(
//               sessionTimeUTC.toLocaleString("en-US", { timeZone: "America/New_York" })
//             );

//             const timeUntilSession = sessionTimeEST - nowEST;
//             const timeSinceSession = nowEST - sessionTimeEST;

//             const isInGracePeriod =
//               (timeUntilSession <= gracePeriodBeforeMs && timeUntilSession >= 0) ||
//               (timeSinceSession >= 0 && timeSinceSession <= gracePeriodAfterMs);

//             const isUpcoming = timeUntilSession > 0;

//             if (isInGracePeriod || isUpcoming) {
//               hasEligibleMeeting = true;
//             }

//             const formattedTimeEST = sessionTimeEST.toLocaleString("en-US", {
//               month: "2-digit",
//               day: "2-digit",
//               year: "numeric",
//               hour: "2-digit",
//               minute: "2-digit",
//               hour12: true,
//             }) + " EST";

//             if (!acc[roomId]) {
//               acc[roomId] = [];
//             }

//             acc[roomId].push({
//               meetingID: room.meetingID,
//               sessionStartTimeEST: formattedTimeEST,
//               sessionStartTimeUTC: sessionTimeUTC.toISOString(),
//               isAvailable: isInGracePeriod,
//               isUpcoming,
//               online: room.online.some((status) => status === true),
//             });

//             return acc;
//           }, {});

//           Object.keys(roomSessionsMap).forEach((roomId) => {
//             roomSessionsMap[roomId].sort(
//               (a, b) =>
//                 new Date(a.sessionStartTimeUTC) - new Date(b.sessionStartTimeUTC)
//             );
//           });

//           const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce((acc, [roomId, sessions]) => {
//             const nextSession = sessions.find((session) => session.isAvailable || session.isUpcoming);
//             if (nextSession) {
//               acc[roomId] = nextSession.sessionStartTimeEST;
//             }
//             return acc;
//           }, {});

//           const onlineStatusMap = Object.entries(roomSessionsMap).reduce((acc, [roomId, sessions]) => {
//             acc[roomId] = sessions.some((session) => session.online);
//             return acc;
//           }, {});

//           setRoomsOnlineStatus(onlineStatusMap);
//           setEnabledRoom(roomSessionsMap);
//           setSessionStartTimes(sessionStartTimesMap);
//           setMeetingExists(hasEligibleMeeting);
//         } else {
//           setMeetingExists(false);
//         }
//       } catch (error) {
//         console.error("[ClientTherapyRooms] Failed to fetch meeting details:", error);
//         setMeetingExists(false);
//       }
//     }

//     setLoading(false);
//   };

//   initializeState();
// }, [PlutonicuserID]);


useEffect(() => {
  const initializeState = async () => {
    const savedUserID = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    const savedNickname = currentNickname || localStorage.getItem("currentNickname");

    if (savedNickname) {
      setCurrentNickname(savedNickname);
    }

    if (savedUserID) {
      try {
        const response = await axios.get(
          `${Env.REACT_APP_PYTHON_API_URL}/api/GetMeetings/${savedUserID}`
        );

        if (response.data.length > 0) {
          const nowUTC = new Date(); // current time in UTC

          const gracePeriodBeforeMs = 10 * 60 * 1000; // 10 minutes before
          const gracePeriodAfterMs = 50 * 60 * 1000;  // 50 minutes after
          let hasEligibleMeeting = false;

          const roomSessionsMap = response.data.reduce((acc, room) => {
            const roomId = room.meetingID.split("-")[0];
            const sessionTimeUTC = new Date(room.sessionTime); // assuming backend sends UTC

            const timeUntilSession = sessionTimeUTC - nowUTC;
            const timeSinceSession = nowUTC - sessionTimeUTC;

            const isInGracePeriod =
              (timeUntilSession <= gracePeriodBeforeMs && timeUntilSession >= 0) ||
              (timeSinceSession >= 0 && timeSinceSession <= gracePeriodAfterMs);

            const isUpcoming = timeUntilSession > 0;

            if (isInGracePeriod || isUpcoming) {
              hasEligibleMeeting = true;
            }

            // Format for display only
            const formattedTimeEST = sessionTimeUTC.toLocaleString("en-US", {
              timeZone: "America/New_York",
              month: "2-digit",
              day: "2-digit",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
              hour12: true,
            }) + " EST";

            if (!acc[roomId]) {
              acc[roomId] = [];
            }

            acc[roomId].push({
              meetingID: room.meetingID,
              sessionStartTimeEST: formattedTimeEST,
              sessionStartTimeUTC: sessionTimeUTC.toISOString(),
              isAvailable: isInGracePeriod,
              isUpcoming,
              online: room.online.some((status) => status === true),
            });

            return acc;
          }, {});

          // Sort sessions per room
          Object.keys(roomSessionsMap).forEach((roomId) => {
            roomSessionsMap[roomId].sort(
              (a, b) => new Date(a.sessionStartTimeUTC) - new Date(b.sessionStartTimeUTC)
            );
          });

          const sessionStartTimesMap = Object.entries(roomSessionsMap).reduce((acc, [roomId, sessions]) => {
            const nextSession = sessions.find((session) => session.isAvailable || session.isUpcoming);
            if (nextSession) {
              acc[roomId] = nextSession.sessionStartTimeEST;
            }
            return acc;
          }, {});

          const onlineStatusMap = Object.entries(roomSessionsMap).reduce((acc, [roomId, sessions]) => {
            acc[roomId] = sessions.some((session) => session.online);
            return acc;
          }, {});

          setRoomsOnlineStatus(onlineStatusMap);
          setEnabledRoom(roomSessionsMap);
          setSessionStartTimes(sessionStartTimesMap);
          setMeetingExists(hasEligibleMeeting);
        } else {
          setMeetingExists(false);
        }
      } catch (error) {
        console.error("[ClientTherapyRooms] Failed to fetch meeting details:", error);
        setMeetingExists(false);
      }
    }

    setLoading(false);
  };

  initializeState();
}, [PlutonicuserID]);







// ✅ Step 2: Fetch the previously selected space (only if meeting exists)
useEffect(() => {
  if (meetingExists) {
      axios.get(`${Env.REACT_APP_PYTHON_API_URL}/api/get-selected-space/${PlutonicuserID}`)
          .then((res) => {
              const space = res.data.selectedSpace;
              if (space) {
                  console.log("Setting selected space from backend:", space);
                  setSelectedSpace(space);
              } else {
                  console.log("No space selected previously.");
              }
          })
          .catch((err) => console.error("Error fetching selected space:", err));
  }
}, [PlutonicuserID, meetingExists]);


// removed active meeting alert
// useEffect(() => {
//   if (PlutonicuserID) {
//     axios
//       .get(`${Env.REACT_APP_PYTHON_API_URL}/api/get-selected-space/${PlutonicuserID}`)
//       .then((res) => {
//         const space = res.data.selectedSpace;
//         if (space) {
//           console.log("Setting selected space from backend:", space);
//           setSelectedSpace(space);
//         } else {
//           console.log("No space selected previously.");
//         }
//       })
//       .catch((err) => console.error("Error fetching selected space:", err));
//   }
// }, [PlutonicuserID]);



 


// ✅ Step 3: Handle space selection (only if meeting exists)
  const handleSpaceSelection = (spaceId) => {
    console.log("Selected Space ID:", spaceId); 
    if (!meetingExists) {
        alert("No active meeting found. Cannot select a space.");
        return;
    }
    if (selectedSpace === spaceId) {
        console.log("Space is already selected. No API call needed.");
        return; // ✅ Avoid unnecessary API request
    }
  
    setSelectedSpace(spaceId);
    axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/select-space`, 
      { PlutonicuserID: PlutonicuserID,
        selectedSpace: spaceId })
      .then(() => console.log("Space selection updated"))
      .catch((err) => console.error("Error updating space selection:", err));
  };
  
  



  
  const rooms = [
    {
        id: "beach",
        title: "Plutonic Therapy Beach Office",
        description:
            "Consider having a session with your licensed mental health professional inside the office or in the cabana. Take in the sounds of the ocean waves and the sunset as you reduce stress.",
        accessibility: "PC Web Browser | Chrome, Edge",
        style: "Modern Design",
        usage: "Family Counseling",
        image: beach,
        // available: enabledRoom["beach"]?.some((session) => session.isAvailable) || false,
        selectable: enabledRoom["beach"]?.length > 0 ?? false, // Selectable if a meeting exists
        available: enabledRoom["beach"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
        isComingSoon: false,
        online: roomsOnlineStatus["beach"] || false,
        sessionStartTimeEST: sessionStartTimes["beach"] || "",
    },
    {
        id: "mountain",
        title: "Plutonic Therapy Forest Office",
        description:
            "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
        accessibility: "PC Web Browser | Chrome, Edge",
        style: "Modern Design",
        usage: "Family Counseling",
        image: forest,
        // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
        // selectable: false, // Cannot select "coming soon" rooms
        available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
        selectable: enabledRoom["mountain"]?.length > 0 ?? false, // Selectable if a meeting exists
        isComingSoon: false,
        online: roomsOnlineStatus["mountain"] || false,
        sessionStartTimeEST: sessionStartTimes["mountain"] || "",
    },
  //   {
  //     id: "forest",
  //     title: "Plutonic Therapy Forest Office",
  //     description:
  //         "Consider having a session with your licensed mental health professional next to the fireplace. Take in the sounds and sights of the forest.",
  //     accessibility: "PC Web Browser | Chrome, Edge",
  //     style: "Modern Design",
  //     usage: "Family Counseling",
  //     image: forest,
  //     // available: enabledRoom["mountain"]?.some((session) => session.isAvailable) || false,
  //     // selectable: false, // Cannot select "coming soon" rooms
  //     available: enabledRoom["forest"]?.some((session) => session.isAvailable) || false,
  //     selectable: enabledRoom["forest"]?.length > 0 ?? false, // Selectable if a meeting exists
  //     isComingSoon: false,
  //     online: roomsOnlineStatus["forest"] || false,
  //     sessionStartTimeEST: sessionStartTimes["forest"] || "",
  // },
    {
        id: "park",
        title: "Plutonic Therapy Quiet Park",
        description:
            "Consider having a session with your licensed mental health professional while taking a walk around the park or while sitting on a park bench. This quiet park is a perfect safe space to talk.",
        accessibility: "PC Web Browser | Chrome, Edge",
        style: "Green Space",
        usage: "Family Counseling",
        image: park,
        available: enabledRoom["park"]?.some((session) => session.isAvailable) || false,
        selectable: enabledRoom["park"]?.length > 0 ?? false, // Selectable if a meeting exists
        // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
        isComingSoon: false,
        online: roomsOnlineStatus["park"] || false,
        sessionStartTimeEST: sessionStartTimes["park"] || "",
    },
    {
      id: "campsite",
      title: "Plutonic Therapy Campsite",
      description:
          "Unpack your thoughts with your licensed mental health professional next to the campfire. Trees swaying and crickets chirping while enjoying the beautiful night sky. ",
      accessibility: "PC Web Browser | Chrome, Edge",
      style: "Green Space",
      usage: "Family Counseling",
      image: campsite,
      available: enabledRoom["campsite"]?.some((session) => session.isAvailable) || false,
      selectable: enabledRoom["campsite"]?.length > 0 ?? false, // Selectable if a meeting exists
      // enterable: enabledRoom["park"]?.some((session) => session.isAvailable) ?? false, // Enterable only if within grace period
      isComingSoon: true,
      online: roomsOnlineStatus["campsite"] || false,
      sessionStartTimeEST: sessionStartTimes["campsite"] || "",
  },
];


const handleEnterClick = (roomType) => {
  // console.log(`[TherapyRooms] Attempting to enter room: ${roomType}`);

  // Handle test-beach and test-park explicitly
  if (roomType === "test-beach" || roomType === "test-park" || roomType === "test-forest") {
    const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
    const testMeetingID = `${roomType}-test-meeting-id`; // Mock meeting ID based on room type

    // console.log(`[TherapyRooms] Test room clicked: ${roomType}`);
    sessionStorage.setItem("meetingID", testMeetingID); // Set mock meeting ID
    sessionStorage.setItem("userId", userId); // Set user ID

    const realRoomType = 
    roomType === "test-beach" ? "beach" : 
    roomType === "test-park" ? "park" : 
    roomType === "test-forest" ? "forest" : ""; 

  console.log(`[TestPage] Navigating to Unity build for ${realRoomType} room`);
  navigate(`/unity-room/${realRoomType}`); 
  return;
}

  // Handle other real rooms
  const roomSessions = enabledRoom[roomType];
  if (!roomSessions || roomSessions.length === 0) {
    alert("Room is not enabled. Please wait or check your eligibility.");
    // console.log(`[TherapyRooms] No sessions available for room: ${roomType}`);
    return;
  }

  const session = roomSessions.find((s) => s.isAvailable);
  if (!session) {
    alert("No active session is available at this time.");
    // console.log(`[TherapyRooms] No active session found for room: ${roomType}`);
    return;
  }

  const userId = PlutonicuserID || localStorage.getItem("PlutonicuserID");
  sessionStorage.setItem("meetingID", session.meetingID);
  sessionStorage.setItem("userId", userId);

  // console.log(`[TherapyRooms] Navigating to /unity-room/${roomType}`);
  navigate(`/unity-room/${roomType}`);
};






  if (loading) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div>
      <Navbar
        setCurrentNickname={(nickname) => {
          setCurrentNickname(nickname);
          localStorage.setItem("currentNickname", nickname);
        }}
        currentNickname={currentNickname}
        handleLogout={handleLogout}
        setFormType={setFormType}
        showButtons={true}
        PlutonicuserID={
          PlutonicuserID || localStorage.getItem("PlutonicuserID")
        }
        navbarBanner="Breaking the Stigma. This Month, Let's Talk About It."
      />
      <div
      
        className="flex flex-col items-center min-h-screen pt-24 pb-16 px-12 mx-auto"
        style={{
          background: "linear-gradient(to bottom, #CBCECE, #77D8EE, #CBCECE)",
        }}
      >
        <h2 className="text-3xl font-bold mb-8 self-start pl-4 mt-8">
          Your Virtual Spaces
        </h2>
        <h2 className="text-xl font-bold mb-4 self-start pl-4 ">Select Your Preferred Session Space</h2>

        <div className="grid gap-8 grid-cols-1 md:grid-cols-2 lg:grid-cols-3 w-full">
          {rooms.map((room) => (
            <TherapyRoomCard
              key={room.id}
              image={room.image}
              title={room.title}
              description={room.description}
              accessibility={room.accessibility}
              style={room.style}
              usage={room.usage}
              available={room.available}
              isComingSoon={room.isComingSoon}
              userType={userType}
              online={room.online}
              sessionStartTimeEST={room.sessionStartTimeEST} // Pass session start time
              onEnterClick={() => handleEnterClick(room.id)}
              isSelected={selectedSpace === room.id}
              onSelect={() => handleSpaceSelection(room.id)}
            />
          ))}


        </div>


      </div>
      <Footer />
    </div>
  );
}

export default ClientTherapyRooms;
